import { Buildings, Info, MapPin, Phone, XCircle } from "@phosphor-icons/react"
import { CodenameTag, MenuDivider, Note } from "@vesatogo/grass-core"
import { Link } from "react-router-dom"
import { NoCreditLimitNote } from "~/components/CreditManagement/NoCreditLimitNote"
import { UserCreditSummary } from "~/components/CreditManagement/UserCreditSummary"
import { AppRoutes } from "~/constants/routes"

export type UserDetailsType = {
  user?: any
  type?: "seller" | "buyer"
  creditForm?: any
  hideCreditDetails?: boolean
  creditFetching?: boolean
}

const UserDetailsCard = ({
  user,
  type = "seller",
  creditForm,
  hideCreditDetails,
  creditFetching = false,
}: UserDetailsType) => {
  if (!user) return null

  const credit = creditForm?.values?.credit
  return (
    <div className="bg-gray-100 rounded p-2 flex flex-col gap-2 text-sm">
      <div className="flex items-center gap-1">
        <Info weight="fill" className="text-blue-300" size={18} />
        <span className="text-gray-800 font-600 ">
          {`${type === "seller" ? "Supplier" : "Buyer"} Personal Info.`}
        </span>
      </div>
      <div className="ml-4 flex flex-col gap-2 text-gray-800">
        <div>
          <CodenameTag
            referenceId={
              user.external_reference_id || user.external_reference_id2 || "na"
            }
          ></CodenameTag>
        </div>
        <div className="flex gap-1 items-center">
          <Phone className="text-blue-300" size={18} />
          {user.number || "na"}
        </div>

        <div className="flex gap-1 items-center">
          <MapPin className="text-blue-300" size={18} />
          {user.current_address?.raw_address || "na"}
        </div>
        <div className="flex gap-1 items-center">
          <Buildings className="text-blue-300" size={18} />
          {user.companies?.map(c => c.company?.display_name).join(", ") || "na"}
        </div>
      </div>

      {type === "buyer" && !hideCreditDetails && (
        <>
          <MenuDivider className="border-1 border-gray-300 border-dashed" />
          <div className="flex justify-between">
            <div className="flex items-center gap-1">
              <Info weight="fill" className="text-blue-300" size={18} />
              <span className="text-gray-800 font-600 ">
                Buyer Credit Info.
              </span>
            </div>

            <div className="underline text-blue-300">
              <Link
                to={AppRoutes.creditDetail(
                  credit?.latest_verified_credit_wallet_request_id || "new"
                )}
                target="_blank"
                hidden={
                  credit?.latest_verified_credit_wallet_request_id
                    ? false
                    : hideCreditDetails
                }
              >
                {`Credit ${
                  credit?.latest_verified_credit_wallet_request_id
                    ? "details"
                    : "Mgnt"
                }>>`}
              </Link>
            </div>
          </div>
          {credit?.error && (
            <Note
              intent="danger"
              className="text-sm flex gap-2 items-center border-l-4 border-red-500 mt-3"
            >
              <XCircle weight="fill" className="text-red-500" size={18} />
              Something went wrong fetching Credit data!
            </Note>
          )}
          {!credit?.error &&
            !credit?.latest_verified_credit_wallet_request_id && (
              <NoCreditLimitNote fetching={creditFetching} />
            )}
          {Boolean(credit?.latest_verified_credit_wallet_request_id) && (
            <UserCreditSummary credit={credit} />
          )}
        </>
      )}
    </div>
  )
}

export default UserDetailsCard
